import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGangContext } from "./useGang.ts";

export function DuplicateGangDialog() {
  const { gang } = useGangContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Duplicate gang?"
      description={`${gang.name} will be duplicated. Zing!`}
      submitLabel="Duplicate"
      onSubmit={() => database.gangs.duplicateOne(gang)}
      onSuccess={(gangId) => {
        toast("Gang duplicated");
        navigate(`~/gangs/g/${gangId}`);
      }}
    />
  );
}
